import React from "react"
import { Form, Row, Col } from "react-bootstrap"
import InputError from "../../InputError/InputError"

function DateTimeField({
  required,
  type,
  formLabel,
  size,
  placeholder,
  name,
  value,
  onChange,
  isError,
  errorMessage = "",
  className,
  min,
}) {
  return (
    <Form>
      {type === "inline" ? (
        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Row>
            <Col sm={4}>
              <Form.Label className="form-label align-left">
                {formLabel}
                {required && <span className="badge">*</span>}
              </Form.Label>
            </Col>
            <Col sm={6}>
              <Form.Control
                type="datetime-local"
                className={className}
                placeholder={placeholder}
                size={size}
                name={name}
                value={value}
                onChange={onChange}
                min={min}
              />
              <InputError
                isValid={isError}
                message={
                  errorMessage !== "" ? errorMessage : "This field is required"
                }
              />
            </Col>
          </Row>
        </Form.Group>
      ) : (
        <>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            {formLabel && (
              <Form.Label className="align-left form-label">
                {formLabel}
                {required && <span className="badge">*</span>}
              </Form.Label>
            )}
            <Form.Control
              type="datetime-local"
              className={className}
              placeholder={placeholder}
              size={size}
              name={name}
              value={value}
              onChange={onChange}
              min={min}
            />
            <InputError
              isValid={isError}
              message={
                errorMessage !== "" ? errorMessage : "This field is required"
              }
            />
          </Form.Group>
        </>
      )}
    </Form>
  )
}

export default DateTimeField
